import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

type SectionLabelProps = {
  children: ReactNode;
  right?: ReactNode;
};

/** Overline-style section header used across active-phase screens. */
export const SectionLabel = ({ children, right }: SectionLabelProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      mb: 1,
    }}
  >
    <Typography
      component="h2"
      sx={{
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: 'text.tertiary',
      }}
    >
      {children}
    </Typography>
    {right}
  </Box>
);
